import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  ToolsService,
  EmailSubscriptionItemDto,
  UpdateEmailSubscriptionsRequest
} from '../../services/tools.service';

@Component({
  selector: 'app-email-subscriptions',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule],
  templateUrl: './email-subscriptions.component.html',
  styleUrls: ['./email-subscriptions.component.css']
})
export class EmailSubscriptionsComponent implements OnInit {

  subscriptions: EmailSubscriptionItemDto[] = [];
  isLoading = false;
  isSaving = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;

  constructor(
    private toolsService: ToolsService,
    public dialogRef: MatDialogRef<EmailSubscriptionsComponent>
  ) {}

  ngOnInit(): void {
    this.load();
  }

  private load(): void {
    this.isLoading = true;
    this.errorMessage = null;
    this.toolsService.getEmailSubscriptions().subscribe({
      next: (response) => {
        this.subscriptions = response.subscriptions;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = 'Failed to load email subscriptions.';
        this.isLoading = false;
        console.error(err);
      }
    });
  }

  save(): void {
    this.isSaving = true;
    this.errorMessage = null;
    this.successMessage = null;

    const request: UpdateEmailSubscriptionsRequest = {
      subscriptions: this.subscriptions
        .filter(s => !s.isReadOnly)
        .map(s => ({ emailTypeId: s.emailTypeId, isSelected: s.isSelected }))
    };

    this.toolsService.updateEmailSubscriptions(request).subscribe({
      next: () => {
        this.isSaving = false;
        this.successMessage = 'Subscriptions saved successfully.';
      },
      error: (err) => {
        this.isSaving = false;
        // Extract the real detail from the API ProblemDetails response
        const detail: string =
          err?.error?.detail ||
          err?.error?.title ||
          err?.error ||
          err?.message ||
          'Unknown error';
        this.errorMessage = `Failed to save: ${detail}`;
        console.error('Email subscription save error:', err);
      }
    });
  }
}
